import Swiper from "swiper";
import { Pagination, Navigation } from "swiper/modules";


// configure Swiper to use modules
Swiper.use([Pagination]);

(function () {
  const videoImageslider = document.querySelectorAll(".video-image-slider");
  let videoImageSwiper = [];

  for (let i = 0; i < videoImageslider.length; i++) {
    videoImageSwiper[i] = new Swiper(videoImageslider[i], {
      modules: [Pagination, Navigation],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        920: {
          slidesPerView: 3,
        },
      },
    });
  }

  const byImageslider = document.querySelectorAll(".mb-imageslider");
  let imageSwiper = [];

  for (let i = 0; i < byImageslider.length; i++) {
    imageSwiper[i] = new Swiper(byImageslider[i], {
      modules: [Pagination, Navigation],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        920: {
          slidesPerView: 3,
        },
      },
    });
  }
})();
